import api from './api';

export const whatsappAPI = {
  // Listar conversas
  listarConversas: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
        queryParams.append(key, params[key]);
      }
    });
    const queryString = queryParams.toString();
    return api.get(`/whatsapp/conversations${queryString ? `?${queryString}` : ''}`);
  },

  // Buscar mensagens de uma conversa
  buscarMensagens: (chatId, params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
        queryParams.append(key, params[key]);
      }
    });
    const queryString = queryParams.toString();
    return api.get(`/whatsapp/conversations/${chatId}/messages${queryString ? `?${queryString}` : ''}`);
  },

  // Enviar mensagem
  enviarMensagem: (dados) => {
    return api.post('/whatsapp/send-message', dados);
  },

  // Enviar mensagem de texto simples
  enviarTexto: (dados) => {
    return api.post('/whatsapp/send-text', dados);
  },

  // Verificar status da instância
  verificarStatus: () => {
    return api.get('/whatsapp/instance/status');
  },

  // Conectar instância
  conectarInstancia: () => {
    return api.post('/whatsapp/instance/connect');
  },

  // Desconectar instância
  desconectarInstancia: () => {
    return api.post('/whatsapp/instance/disconnect');
  },

  // Baixar áudio descriptografado
  baixarAudio: (messageData) => {
    return api.post('/whatsapp/download-audio', { messageData }, {
      responseType: 'blob'
    });
  }
};
